export default {
    addSpecialWorkday: 'Add Special Workday',
    editSpecialWorkday: 'Edit Special Workday',
    specialWorkdayName: 'Special Workday Name',
    forGroup: 'For Group',
    workday: 'Workday',
    checkinTime: 'Checkin Time',
    startTime: 'Start Time',
    breakTime: 'Break Time',
    endTime: 'End Time',
    description: 'Description',
    save: 'Save',
    msgError: 'Error Message',
    congratulation: 'Congratulation',
    msgErrorStartTimeAndEndTime: 'start time should less than end time',
    msgCreateSuccess: 'Special Workday is created.',
    msgUpdateSuccess: 'Special Workday is updated.',
    msgRequiredField: 'This field is required',
    msgLimitCharacters: 'This field should be less than 255 characters'
}
